import { Component, ElementRef, ViewChild, Inject, PLATFORM_ID, AfterViewInit, Renderer2 } from '@angular/core';
import { FormGroup, FormBuilder, Validators, isFormArray } from '@angular/forms';
import { PeriodService } from '../../../../periods/period.service';
import { UserService } from '../../../../user/services/user.service';
import { ConceptResponseService } from '../../../services/concept_response.service';
import Swal from 'sweetalert2';
import { EmployeeConceptService } from '../../../../concepts/services/employee_concepts.service';
import { ReportResponseService } from '../../../services/report_response.service';
import { ExpenseService } from '../../../services/expense.service';
import { ExpenseAttachmentsService } from '../../../../shared/services/expense_attachments.service';
import { Modal } from 'bootstrap';
import { isPlatformBrowser } from '@angular/common';
import { SystemSettingsService } from '../../../../shared/services/system_settings.service';
import { response } from 'express';

@Component({
  selector: 'app-add-edit-concept-response',
  templateUrl: './add-edit-concept-response.component.html',
  styleUrl: './add-edit-concept-response.component.scss'
})
export class AddEditConceptResponseComponent implements AfterViewInit {
  @ViewChild('addExpenseModal', { static: false }) modalElement!: ElementRef; modalInstance!: Modal;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('AttachmentModal', { static: false }) attachmentModalElement!: ElementRef; attachmentModalInstance!: Modal;
  isRContainersVisible = false; // Controla la visibilidad del contenedor izquierdo
  reportResponseId: any = ''
  conceptResponseId: string = ''; // Id del concepto de respuesta seleccionado
  expenseId: string = ''; // Id del gasto seleccionado
  selectedFiles: File[] = [];
  employeeId = this.userService.getselectedUserId() 
  periodId: any

  expenseForm: FormGroup;
  conceptResponseForm: FormGroup;

  expenses: any[] = []
  concepts: any[] = [];

  totalCR: any = 0

  currentStateReportName: string = ''
  reportResponseData: any = {}
  systemConfigurations: any

  userCanEdit: boolean = false

  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private fb: FormBuilder,
    private periodService: PeriodService,
    private userService: UserService,
    private conceptResponseService: ConceptResponseService,
    private conceptService: EmployeeConceptService,
    private reportService: ReportResponseService,
    private expenseService: ExpenseService,
    private expenseAttachmentsService: ExpenseAttachmentsService,
    private configurationService: SystemSettingsService
  ) {
    this.expenseForm = this.fb.group({
      conceptResponseId: ['', Validators.required],
      description: ['', Validators.required],
      value: [''],
      /*       attachments: this.fb.array([]) */
    });

    this.conceptResponseForm = this.fb.group({
      reportResponseId: ['', Validators.required],
      employeeConceptId: ['', Validators.required],
      periodId: [this.periodId, Validators.required],
      userId: [this.employeeId, Validators.required],
      vote: [''],
      value: [''],
      valueToPay: [''],
      comment: [''],
      /*expenses: this.fb.array([])  */
    });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId) && this.modalElement?.nativeElement) {
      import('bootstrap').then(({ Modal }) => {
        this.modalInstance = new Modal(this.modalElement.nativeElement);
      }).catch(error => console.error('Error al importar Bootstrap Modal:', error));
    }
  }

  ngOnInit(): void {
      this.userService.userCanEdit$.subscribe(userCanEdit => {
        if (userCanEdit) {
          this.userCanEdit = userCanEdit
        }
      })

    //detecta cambios en el periodo y en base a eso buscar los conceptos del usuario y reportResponse si es que existe    
    this.periodService.selectedPeriodId$.subscribe(period => {
      if (period) {
        this.periodId = period
        //this.loadEmployeeConcepts(); migramos esta funcion a getReporResponse
        this.conceptResponseForm.patchValue({
          periodId: period
        })
        this.getReportResponse(period, this.employeeId)
        //nueva función de verificación
      }
    })


    // detecta al cargar el ID del informe y no es necesario getReportResponse
    this.reportService.selectedReportResponseId$.subscribe(reportResponseId => {
      if (reportResponseId) {
        this.reportResponseId = reportResponseId
        this.conceptResponseForm.patchValue({
          reportResponseId: reportResponseId
        })
        this.reportResponseData = {}
        //funcion para cargar el periodo en base al ID del informe
        this.reportService.getById(reportResponseId).subscribe((response: any) => {
          if (response) {
            this.reportResponseData = response
            this.employeeId=response.userId
            this.periodId = response.periodId
            this.conceptResponseForm.patchValue({
              periodId: this.periodId
            })
            this.loadEmployeeConcepts();
            //nueva función de verificación
          }
        })
      }
    })

    //cuando recibimos la solicitud de editar el conceptresponse desde la pestaña Informe especificamante componente list components 
    this.reportService.dataToEdit$.subscribe(data => {
      if (data) {
        this.setEmployeeConceptId(data)
      }
    })

    this.configurationService.get().subscribe(variables => {
      if (variables) {
        this.systemConfigurations = variables
      }
    })
  }
  getReportResponse(periodId: String, userId: String) {
    this.reportResponseData = {}
    this.reportService.get(periodId, userId).subscribe({
      next: (response: any) => {
        if (response.length == 1) {
          this.reportResponseData = response[0]
          this.reportResponseId = response[0]._id
          this.conceptResponseForm.patchValue({
            reportResponseId: response[0]._id
          })
          this.loadEmployeeConcepts();
        } else {
          Swal.fire('Error', 'Hay mas de 1 reporte creado para el usuario en el mismo periodo, lo cual es un error, avisar al administrador porfavor', 'error')
        }
      }, error: (err) => {
        Swal.fire('Error', 'Ocurrió un error al obtener el reporte', 'error');
        console.error('Error obteniendo reportes:', err);
      }
    })
  }

  setEmployeeConceptId(data: any): void {
    this.conceptResponseId = data.conceptResponseId
    this.conceptResponseForm.patchValue(data)
    this.loadConceptResponse({ target: { value: data.employeeConceptId } });
  }

  disableCRControls() {
    this.conceptResponseForm.get('vote')?.disable();
    this.conceptResponseForm.get('comment')?.disable();
  }

  enableCRControls() {
    this.conceptResponseForm.get('vote')?.enable();
    this.conceptResponseForm.get('comment')?.enable();
  }

  loadEmployeeConcepts(): void {
    if (!this.periodId || !this.employeeId) {
      Swal.fire('Error', 'No se ha seleccionado un periodo o empleado', 'error');
      return;
    }
    Swal.fire({
      title: 'Cargando Conceptos del usuario...',
      html: 'Por favor espera',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.conceptService.getView(this.employeeId, this.periodId, true).subscribe({
      next: (data: any) => {
        this.concepts = data || [];
        Swal.close()        
      },
      error: (err) => {
        console.error('Error al cargar los conceptos:', err);
        Swal.fire('Error', 'No se pudieron cargar los conceptos', 'error');
        Swal.close()
      }
    });
  }

  verifyConceptResponse(event: any): void {
    setTimeout(() => {
      this.conceptResponseId = ''
      this.resetCRForm()
    }, 120)
    this.loadConceptResponse(event);
  }

  loadConceptResponse(event: any): void {
    setTimeout(() => {
      const employeeConceptId = event.target.value;
      if (!employeeConceptId || employeeConceptId == '') {
        Swal.fire('Error', 'No se ha seleccionado un concepto', 'error');
        return;
      }
      this.expenses = [];

      this.conceptResponseForm.patchValue({
        employeeConceptId: employeeConceptId
      });

      this.conceptResponseService.getByEC(employeeConceptId).subscribe((response: any) => {
        if (response) {
          //this.isEditCR = true;
          if (response.length) {
            Swal.fire('Concepto Cargado', 'Se ha cargado la información del concepto', 'success');
            this.conceptResponseId = response[0]._id;
            this.conceptResponseForm.patchValue({
              vote: response[0].vote,
              value: response[0].value,
              comment: response[0].comment,
              valueToPay: response[0].valueToPay
            });
            this.loadExpenses();
          } else {
          }

        }

      },
      );
    }, 100);
  }

  loadExpenses(updateTotals?: boolean): void {
    Swal.fire({
      title: 'Cargando Gastos...',
      html: 'Por favor espera',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.expenseService.get(this.conceptResponseId).subscribe((data) => {
      if (data) {
        this.expenses = data;
        Swal.close();
        this.totalCR = this.expenses.reduce((acc, e) => acc + Number(e.value || 0), 0);
        if (updateTotals) {
          this.updateTotalCR()
        }
      } else {
        Swal.close();
      }
    }
    );
  }

  toggleRContainers(): void {
    this.isRContainersVisible = !this.isRContainersVisible;
  }


  uploadAttachment(event: any): void {
    const file = event.target.files[0];
  }

  onAddExpense() {
    if (this.conceptResponseForm.invalid) {
      Swal.fire('Error', 'Faltan campos por completar en el Concepto. Completa antes de agregar un gasto.', 'error');
      return;
    }
    this.resetEForm()
    this.openModal()
  }


  onSaveExpense() {
    if (this.conceptResponseId === "") {
      //sino existe conceptResponse hay que crearla
      this.saveConceptResponse(true);
      //this.isEditCR = false;
    } else {
      this.saveExpense(this.expenseId !== '');
    }
  }

  onFilesSelected(event: any): void {
    const files = Array.from(event.target.files) as File[];

    const allowedTypes = this.systemConfigurations?.allowed_file_types || ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'];
    const maxSize = (this.systemConfigurations?.max_file_size_mb || 50) * 1024 * 1024; // Convert MB to bytes

    const validFiles = files.filter(file => allowedTypes.includes(file.type));
    const invalidFiles = files.filter(file => !allowedTypes.includes(file.type));
    if (invalidFiles.length > 0) {
      Swal.fire('Archivos no válidos', `Solo se permiten: ${allowedTypes.join(', ')}`, 'error');
    }

    const tooLargeFiles = validFiles.filter(file => file.size > maxSize);
    const acceptedFiles = validFiles.filter(file => file.size <= maxSize);

    if (tooLargeFiles.length > 0) {
      Swal.fire('Archivo muy grande', `Cada archivo debe pesar menos de ${this.systemConfigurations?.max_file_size_mb || 50}MB.`, 'error');
    }

    this.selectedFiles.push(...acceptedFiles);
  }

  removeSelectedFile(file: File): void {
    this.selectedFiles = this.selectedFiles.filter(f => f !== file);
  }

  uploadAttachments(expenseId: string, conceptResponseId: string): void {
    if (!this.selectedFiles || this.selectedFiles.length === 0) {
      Swal.fire('Error', 'No se ha seleccionado ningun resplado, favor ingresar al menos 1 archivo de respaldo', 'error');
      return;
    }
    Swal.fire({
      title: 'Subiendo Archivos...',
      html: 'Por favor espera',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    const formData = new FormData();
    formData.append('expenseId', expenseId);
    formData.append('conceptResponseId', conceptResponseId);
    for (let file of this.selectedFiles) {
      formData.append('attachments', file);
    }

    this.expenseAttachmentsService.saveMany(formData).subscribe({
      next: (response: any) => {
        Swal.fire('Éxito', 'Archivos subidos correctamente', 'success');
        this.selectedFiles = []; // Limpiar archivos después de subirlos
        this.fileInput.nativeElement.value = '';
        this.loadExpenses(true);
        this.closeModal();
        Swal.close()
      },
      error: (err: any) => {
        Swal.close()
        console.error('Error al subir archivos:', err);
        Swal.fire('Error', 'No se pudieron subir los archivos', 'error');
      }
    });
  }

  saveExpense = (isUpdating: Boolean): void => {
    // Guard clause: require at least one attachment for new expenses
    if (!isUpdating && (!this.selectedFiles || this.selectedFiles.length === 0)) {
      console.log('Detenido por falta de adjuntos');
      Swal.fire({
        icon: 'error',
        title: 'Adjuntos requeridos',
        text: 'Para guardar un nuevo gasto debes agregar al menos un archivo de respaldo (ej. boleta, imagen, PDF).',
        confirmButtonText: 'Entendido'
      });
      return;
    }
    //verificar que exista conceptResponse
    this.expenseForm.patchValue({
      conceptResponseId: this.conceptResponseId
    });
    if (this.expenseForm.invalid) {
      Swal.fire('Error', 'Faltan campos por completar en el Gasto', 'error');
      return;
    }

    Swal.fire({
      title: 'Guardando Archivos...',
      html: 'Por favor espera',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(); // Esto muestra el spinner de carga
      }
    });

    const expense = this.expenseForm.value;//para evitar problema de adjuntos se formatea el formulario 
    let sExpense = '';
    if (this.expenseId) {
      this.expenseService.update(this.expenseId, expense).subscribe((data: any) => {
        if (data) {
          sExpense = this.expenseId;
          this.uploadAttachments(sExpense, this.conceptResponseId);
          setTimeout(() => {
            this.loadExpenses(true);
          }, 100);
          Swal.close()
          Swal.fire('Éxito', 'Gasto actualizado', 'success');
          this.closeModal();
        }
      });
    } else {
      this.expenseService.save(expense).subscribe({
        next: (data: any) => {
          if (!data?.Expense._id) {
            Swal.close()
            Swal.fire('Error', 'No se pudo guardar el gasto y sus adjuntos', 'error');
            return;
          }
          const sExpense = data.Expense._id;
          Swal.close()
          Swal.fire('Éxito', 'Gasto guardado', 'success');
          this.uploadAttachments(sExpense, this.conceptResponseId);
          setTimeout(() => {
            this.loadExpenses(true);
          }, 100);

        },
        error: () => {
          Swal.fire('Error', 'No se pudo guardar el gasto', 'error');
        }
      });

    }
    Swal.close()
  }

  saveConceptResponse = (saveWithExpense?: boolean): void => {
    if (this.conceptResponseForm.invalid) {
      Swal.fire('Error', 'Faltan campos por completar en el Concepto', 'error');
      console.log('Formulario:', this.conceptResponseForm);
      return;
    }
    Swal.fire({
      title: 'Guardando Información...',
      html: 'Por favor espera',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(); // Esto muestra el spinner de carga
      }
    });
    const conceptResponse = {
      reportResponseId: this.conceptResponseForm.get('reportResponseId')?.value,
      employeeConceptId: this.conceptResponseForm.get('employeeConceptId')?.value,
      periodId: this.periodId,
      userId: this.employeeId,
      vote: this.conceptResponseForm.get('vote')?.value,
      comment: this.conceptResponseForm.get('comment')?.value
    }
    /* this.conceptResponseForm.value; no copiamos completo para poder excluir el value*/

    if (this.conceptResponseId) {
      this.conceptResponseService.update(this.conceptResponseId, conceptResponse).subscribe(() => {
        Swal.close()
         this.reportService.setSelectedReportResponseId(conceptResponse.reportResponseId)
         Swal.fire('Éxito', 'Concepto actualizado', 'success');
        if (saveWithExpense) {
          Swal.close()
          this.saveExpense(true);
        } else {
          this.loadExpenses(true)
        }
      });
    } else {
      this.conceptResponseForm.patchValue({ value: this.expenseForm.get('value')?.value });
      this.conceptResponseService.save(conceptResponse).subscribe((response) => {
        if (response) {
          Swal.close()
          this.reportService.setSelectedReportResponseId(conceptResponse.reportResponseId)
          Swal.fire('Éxito', 'Concepto guardado', 'success');
          this.conceptResponseId = response.ConceptResponse._id;
          if (saveWithExpense) {
            this.saveExpense(false);
          }
        }

      });
    }
  }

  updateTotalCR() {
    this.conceptResponseService.update(this.conceptResponseId, { value: this.totalCR }).subscribe((res) => {
      if (res) {
        this.conceptResponseForm.patchValue({ value: this.totalCR, valueToPay: res.ConceptResponse.valueToPay })
        this.reportService.setSelectedReportResponseId(this.reportResponseId)
      } else {
        Swal.fire('Error', 'no se pudieron actualizar los valores', 'error')
      }
    })
  }

  resetCRForm(): void {
    this.conceptResponseForm.patchValue({
      employeConceptId: '',
      vote: '',
      value: '',
      valueToPay: '',
      comment: '',
    });
  }

  resetEForm(): void {
    this.expenseForm.patchValue({
      conceptResponseId: '',
      description: '',
      value: '',
    });

    this.selectedFiles = []; // Limpiar archivos seleccionados
    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = ''; // Limpiar el input de archivos
    }
    this.expenseId = ''; // Reiniciar el ID del gasto
  }


  closeModal() {
    if (this.modalInstance) {
      this.modalInstance.hide(); // Cierra el modal
      this.resetEForm
    }
  }

  onOpenAttachment(attachementId: any) {
    this.expenseAttachmentsService.setCurrentAttachmentId(attachementId)
    setTimeout(() => {
      this.openAttachmentModal()
    }, 5)
  }

  openAttachmentModal(): void {
    if (isPlatformBrowser(this.platformId) && this.attachmentModalElement?.nativeElement) {
      import('bootstrap').then(({ Modal }) => {
        this.attachmentModalInstance = new Modal(this.attachmentModalElement.nativeElement);
        this.attachmentModalInstance.show();
      }).catch(error => console.error('Error al inicializar el modal de adjuntos:', error));
    }
  }

  closeAttachmentModal(): void {
    if (this.attachmentModalInstance) {
      this.attachmentModalInstance.hide();
    } else {
      console.warn('Attachment modal instance not initialized');
    }
  }
  openModal() {
    if (!this.modalInstance) {
      import('bootstrap').then(({ Modal }) => {
        this.modalInstance = new Modal(this.modalElement.nativeElement);
        this.modalInstance.show();
      }).catch(error => console.error('Error al inicializar el modal:', error));
    } else {
      this.modalInstance.show();
    }
  }

  onEditExpense(expense: any): void {
    //this.isEditExpense = true;
    this.expenseId = expense._id;
    this.expenseForm.patchValue({
      conceptResponseId: expense.conceptResponseId,
      description: expense.description,
      value: expense.value
    });
    this.openModal();
  }

  //al presionar el botón eliminar Gasto se ejecuta la función
  onDeleteExpense(expense: any): void {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción eliminará el gasto permanentemente.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.expenseService.delete(expense._id).subscribe({
          next: () => {
            Swal.fire('Eliminado', 'El gasto ha sido eliminado.', 'success');
            this.deleteAttachmentsByExpense(expense._id)
          },
          error: () => {
            Swal.fire('Error', 'No se pudo eliminar el gasto.', 'error');
          }
        });
      }
    });
  }

  deleteAttachmentsByExpense(expenseId: string) {
    this.expenseAttachmentsService.deleteAllByExpenseId(expenseId).subscribe((res: any) => {
      if (res) {
        Swal.fire('Eliminados', 'Los Adjuntos asociados han sido eliminados.', 'success');
        this.loadExpenses(true);
      } else {
        Swal.fire('Error', 'No se pudo eliminar el gasto.', 'error');
      }
    },)
  }

}
